import { render, staticRenderFns } from "./Oss.vue?vue&type=template&id=bba09494&"
import script from "./Oss.vue?vue&type=script&lang=js&"
export * from "./Oss.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports